import { computed as v, createElementBlock as c, openBlock as a, createElementVNode as u, createCommentVNode as n, normalizeClass as m, unref as s, createBlock as r, renderSlot as $, toDisplayString as w, createVNode as C, mergeProps as k } from "vue";
import f from "../../atoms/image-element/image-element.vue.js";
import b from "../../atoms/video-element/video-element.vue.js";
import { useGrid as S } from "../../composables/useGrid.js";
import { themeProp as z } from "../../composables/useTheme.js";
import x from "../../molecules/breadcrumbs/breadcrumbs.vue.js";
import B from "../../atoms/eyebrow/eyebrow.vue.js";
import D from "../../molecules/link-back/link-back.vue.js";
import j from "../../molecules/link/link.vue.js";
import { screenProp as A, isScreenSmall as g, isScreenLarge as h } from "../../utils/utilsScreen.js";
/* empty css                     */
import E from "../../_virtual/_plugin-vue_export-helper.js";
const N = { class: "ds-background-color-white" }, L = {
  key: 0,
  class: "ds-text-medium ds-rich-text"
}, O = {
  key: 1,
  class: "ds-buttons-wrapper ds-margin-top-24"
}, V = { key: 1 }, W = {
  key: 0,
  class: "ds-container ds-padding-x-0",
  "data-j-vertical--media": ""
}, I = /* @__PURE__ */ Object.assign({
  name: "DsHeroWithMedia"
}, {
  __name: "hero-with-media",
  props: {
    ...z,
    ...A,
    title: {
      type: String,
      default: ""
    },
    eyebrow: {
      type: String,
      default: ""
    },
    image: {
      type: Object,
      default: null
    },
    aspectRatio: {
      type: String,
      default: null
    },
    video: {
      type: Object,
      default: null
    },
    description: {
      type: String,
      default: ""
    },
    links: {
      type: Array,
      required: !0
    },
    navigationData: {
      type: [Object, Array],
      default: null,
      validator: (e) => Array.isArray(e) ? e.every((l, i, o) => i === o.length - 1 ? "title" in l : ["title", "url"].every((d) => d in l)) : ["text", "url"].every((l) => l in e)
    },
    vertical: {
      type: Boolean,
      default: !1
    },
    alignCenter: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const l = e, i = v(() => l.screen);
    S(i);
    const o = v(() => {
      var t;
      return !((t = l.links) != null && t.length) > 0 ? null : l.links[0];
    }), d = v(() => {
      var t;
      return !((t = l.links) != null && t.length) > 1 ? null : l.links[1];
    }), y = v(() => Array.isArray(l.navigationData));
    return (t, P) => (a(), c("section", N, [
      u("div", {
        class: m(["ds-container", [
          { "ds-padding-top-48": !e.image && !e.video },
          { "wds-container--snap-right": !e.vertical },
          `ds-hero-with-media--${t.theme}`
        ]])
      }, [
        u("div", {
          class: m(["wds-grid", [
            {
              "wds-grid--snap-right-container": (e.image || e.video) && !s(g)(i.value) && s(h)(i.value) && !e.vertical
            },
            { "ds-align-items-center ds-justify-content-center ds-flex-direction-column": e.vertical && e.alignCenter }
          ]])
        }, [
          e.navigationData && e.vertical && e.alignCenter ? (a(), c("div", {
            key: 0,
            class: m({ "wds-grid__col ds-padding-top-48": e.alignCenter }),
            "data-j-vertical-align-breadcrumb": ""
          }, [
            y.value ? (a(), r(x, {
              key: 1,
              theme: t.theme,
              crumbs: e.navigationData,
              "tracking-data": { "component-name": t.$options.name, title: e.title }
            }, null, 8, ["theme", "crumbs", "tracking-data"])) : (a(), r(D, {
              key: 0,
              theme: t.theme,
              "tracking-data": { "component-name": t.$options.name, text: e.navigationData.text, title: e.title },
              text: e.navigationData.text,
              url: e.navigationData.url,
              nuxt: e.navigationData.nuxt
            }, null, 8, ["theme", "tracking-data", "text", "url", "nuxt"]))
          ], 2)) : n("", !0),
          u("div", {
            class: m(["wds-grid__col wds-grid__col--12 ds-display-flex ds-flex-direction-column", [
              e.vertical ? "wds-md-grid__col--12 ds-padding-bottom-48 ds-md-padding-bottom-96" : "wds-md-grid__col--6 wds-lg-grid__col--7",
              { "ds-padding-x-12": s(g)(i.value) },
              e.navigationData ? "ds-justify-content-space-between ds-padding-bottom-48 ds-md-padding-bottom-96" : "ds-align-items-center ds-justify-content-center"
            ]])
          }, [
            e.navigationData && !e.alignCenter ? (a(), c("div", {
              key: 0,
              class: m([
                s(g)(i.value) && !e.vertical ? "ds-margin-top-24" : "ds-margin-top-48",
                { "ds-margin-bottom-48": !s(h)(i.value) && !e.vertical }
              ])
            }, [
              y.value ? (a(), r(x, {
                key: 1,
                theme: t.theme,
                crumbs: e.navigationData,
                "tracking-data": { "component-name": t.$options.name, title: e.title }
              }, null, 8, ["theme", "crumbs", "tracking-data"])) : (a(), r(D, {
                key: 0,
                theme: t.theme,
                "tracking-data": { "component-name": t.$options.name, text: e.navigationData.text, title: e.title },
                text: e.navigationData.text,
                url: e.navigationData.url,
                nuxt: e.navigationData.nuxt
              }, null, 8, ["theme", "tracking-data", "text", "url", "nuxt"]))
            ], 2)) : n("", !0),
            u("div", {
              class: m(["ds-hero-with-media--eyebrow", {
                "ds-lg-padding-right-144 ds-padding-bottom-48 ds-md-padding-bottom-96 ds-lg-padding-y-48": !e.vertical,
                "ds-display-flex ds-flex-direction-column ds-align-items-center ds-text-align-center": e.vertical && e.alignCenter,
                "ds-padding-right-24": !s(g)(i.value) && !e.vertical && !e.alignCenter,
                "ds-padding-top-48": e.vertical,
                "ds-md-padding-top-96": e.vertical && !e.navigationData,
                "ds-sm-padding-top-24 ds-sm-margin-top-24 ds-md-padding-top-48 ds-md-margin-top-48 ds-lg-margin-top-0": !s(h)(i.value) && !e.navigationData && !e.vertical
              }]),
              "data-j-content-block": ""
            }, [
              e.eyebrow ? (a(), r(B, {
                key: 0,
                text: e.eyebrow,
                theme: t.theme,
                class: "ds-margin-bottom-12"
              }, null, 8, ["text", "theme"])) : n("", !0),
              u("div", null, [
                e.title ? (a(), c("h1", {
                  key: 0,
                  class: m(["ds-heading-xlarge ds-margin-bottom-12", { "ds-margin-top-12": e.eyebrow }])
                }, w(e.title), 3)) : n("", !0)
              ]),
              $(t.$slots, "description", {}, () => [
                e.description ? (a(), c("div", L, w(e.description), 1)) : n("", !0)
              ], !0),
              o.value || d.value ? (a(), c("div", O, [
                C(j, {
                  url: o.value.url,
                  "open-in-new-window": o.value.openInNewWindow,
                  nuxt: o.value.nuxt,
                  "lazy-url-endpoint": o.value.lazyUrlEndpoint,
                  content: o.value.title,
                  "tracking-data": { "component-name": t.$options.name, text: o.value.title, title: e.title },
                  type: "button",
                  variant: "primary"
                }, null, 8, ["url", "open-in-new-window", "nuxt", "lazy-url-endpoint", "content", "tracking-data"]),
                d.value ? (a(), r(j, {
                  key: 0,
                  url: d.value.url,
                  "open-in-new-window": d.value.openInNewWindow,
                  "lazy-url-endpoint": d.value.lazyUrlEndpoint,
                  nuxt: d.value.nuxt,
                  content: d.value.title,
                  "icon-right": { category: "arrows", name: "chevron-right-small" },
                  "tracking-data": { "component-name": t.$options.name, text: d.value.title, title: e.title },
                  variant: "secondary"
                }, null, 8, ["url", "open-in-new-window", "lazy-url-endpoint", "nuxt", "content", "tracking-data"])) : n("", !0)
              ])) : n("", !0)
            ], 2),
            e.navigationData && !e.vertical ? (a(), c("div", V)) : n("", !0)
          ], 2),
          !e.vertical && (e.image || e.video) ? (a(), c("div", {
            key: 1,
            class: m(["wds-grid__col wds-grid__col--12 wds-md-grid__col--6 wds-lg-grid__col--5", { "wds-grid__col--no-gutter": s(g)(i.value) }]),
            "data-j-horizontal--media": ""
          }, [
            e.video ? (a(), r(b, k({ key: 0 }, e.video, {
              screen: i.value,
              class: "ds-hero-with-media--video",
              "full-height": ""
            }), null, 16, ["screen"])) : e.image ? (a(), r(f, {
              key: 1,
              class: "ds-hero-with-media--image",
              screen: i.value,
              image: e.image,
              "aspect-ratio": e.aspectRatio,
              style: { height: "100% !important" }
            }, null, 8, ["screen", "image", "aspect-ratio"])) : n("", !0)
          ], 2)) : n("", !0)
        ], 2)
      ], 2),
      e.vertical && (e.image || e.video) ? (a(), c("div", W, [
        e.video ? (a(), r(b, k({ key: 0 }, e.video, {
          screen: i.value.name,
          class: "ds-hero-with-media--video",
          "full-height": ""
        }), null, 16, ["screen"])) : e.image ? (a(), r(f, {
          key: 1,
          image: e.image,
          screen: i.value,
          class: "ds-hero-with-media--image",
          "aspect-ratio": e.aspectRatio,
          style: { height: "100% !important" }
        }, null, 8, ["image", "screen", "aspect-ratio"])) : n("", !0)
      ])) : n("", !0)
    ]));
  }
}), Y = /* @__PURE__ */ E(I, [["__scopeId", "data-v-dfbe15c4"]]);
export {
  Y as default
};
